export enum StateRoutes {
  BuildMany = 'build-many',
  BuildManyClosedLoop = 'build-many-closed-loop',
  DetectManual = 'detect-manual',
  RefreshPitches = 'refresh-pitches',
}
